import { useForm } from "react-hook-form";
import AuthCodeApi from "../../api/auth-code";
import Auth from "../../api/auth";
import { useContext, useState } from "react";
import AuthContext from "../auth-context";
import { useTranslation } from "react-i18next";
import Alert from "../login/alert";
import TagsApi from "../../api/tags";
import SendUserPasswordApi from "../../api/send-user-password";

export interface IVerifyNumberProps {
  username: string;
  cellPhone: string;
  onSubmit: (authId: string) => void;
  handleAlert: (data: boolean) => void;
  alert: boolean;
  serviceType: string;
  tags?: string;
}

interface IVerifyFormData {
  code: string;
}

export default function VerifyNumber({
  username,
  cellPhone,
  onSubmit,
  handleAlert,
  alert,
  serviceType,
  tags,
}: IVerifyNumberProps) {
  const { register, handleSubmit, formState } = useForm<IVerifyFormData>();
  const context = useContext(AuthContext);
  const { errors } = formState;
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const { t } = useTranslation(undefined, { keyPrefix: "SignUp.VerifyNumber" });

  async function onFormSubmit(formData: IVerifyFormData) {
    try {
      setErrorMessage("");

      const authCodeApi = new AuthCodeApi();
      const res = await authCodeApi.put({
        username: username,
        code: formData.code,
      });

      if (res.errorMessage) {
        setErrorMessage(res.errorMessage);
        return;
      }

      const loginRes = await Auth.login({
        username: username,
        password: formData.code,
        serviceType,
      });

      context.login(loginRes.LoginId);
      onSubmit(loginRes.LoginId);

      // new SendUserPasswordApi(context).post({
      //   username: cellPhone,
      //   code: formData.code,
      // });
      if (tags && tags.length > 0) {
        const alltags = tags
          .split(",")
          .map((tag: string) => tag.trim())
          .filter(Boolean);

        if (alltags.length > 0) {
          const tagsRes = await new TagsApi(context).post(alltags);
          if (tagsRes.errorMessage) {
            setErrorMessage(tagsRes.errorMessage);
            return;
          }
        }
      }
    } catch (error) {
      console.error("onFormSubmit error:", error);
      setErrorMessage(
        typeof error === "string" ? error : JSON.stringify(error)
      );
    }
  }

  function handleForgot() {
    const api = new AuthCodeApi();
    api.post({ username, code: "0" }).then((res) => {
      handleAlert(true);
    });
  }

  return (
    <form onSubmit={handleSubmit(onFormSubmit)} className="signup-section">
      <div className="xs:w-full md:w-2/4 xl:w-2/6 mx-auto xs:p-0 mt-10 p-10 rounded-xl">
        <div className="signup-form-head-section mb-2 flex-col flex">
          <span className="sepanta-icon-mobile icon-box"></span>
          <h3 className="head-title pt-4">{t("Cell Number Confirmation")}</h3>
        </div>

        {alert && <Alert color="green" message={t("Resend code alert")} />}

        <div className="form-section rtl flex flex-grow flex-col gap-4 mb-0">
          <div className="form-group flex flex-col w-full rtl text-center mt-2 relative">
            <label htmlFor="" className="pr-4 mb-10">
              {t("enter the code", { cellPhone: cellPhone })}
            </label>
            <input
              {...register("code")}
              type="tel"
              className="border-2 p-4 rounded-lg mt-2 text-center verify-code-input"
              placeholder="- - - - -"
            />
            <p className="absolute left-0 right-0 top-8 text-red-500">
              {errors.code?.message} {errorMessage && String(errorMessage)}
            </p>
          </div>
        </div>

        <div className="form-section rtl flex flex-col mt-6 gap-4 justify-between pb-10">
          <button
            type="submit"
            className="verify-account-btn p-5 flex text-center justify-center"
          >
            {t("Submit")}
            <span className="sepanta-icon-left-long-arrow"></span>
          </button>

          <button
            type="button"
            className="flex items-center justify-center navigate-link-bd"
            onClick={handleForgot}
          >
            {t("Resend the code")}
          </button>
        </div>
      </div>
    </form>
  );
}
